import { SxProps } from '@mui/material';

export const CardSx: SxProps = {
  padding: '16px 16px 16px 16px',
  borderRadius: 1,
  border: '1px solid rgba(19, 20, 20, 0.12)',
  minWidth: '220px',
  flex: '1 1 0',
  height: 'auto',
  minHeight: '90px',
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  boxShadow: 'none',
  marginTop: 0
};

export const TitleSx: SxProps = {
  fontSize: '14px',
  color: 'text.secondary',
  fontWeight: 500,
  marginBottom: 0.5,
  lineHeight: 1
};

export const ValueSx: SxProps = {
  fontSize: '28px',
  fontWeight: 500,
  color: 'text.primary',
  marginTop: 0,
  lineHeight: 1,
  width: '100%'
};

export const SubtitleSx: SxProps = {
  fontSize: '14px',
  color: 'text.secondary',
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  marginTop: 'auto',
  paddingTop: 1
};

export const TitleTypographySx: SxProps = {
  fontSize: '14px',
  fontWeight: 500,
  color: '#60605D',
  marginBottom: 1
};

export const DefaultCountTypographySx: SxProps = {
  fontSize: '24px',
  fontWeight: 500,
  letterSpacing: '0.5%',
  color: '#131414'
};

export const NegativeCountTypographySx: SxProps = {
  fontSize: '24px',
  fontWeight: 500,
  letterSpacing: '0.5%',
  color: '#F27058'
};

export const RowStackSx: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 0.5
};

export const LinkSx: SxProps = {
  fontWeight: 600,
  fontSize: '14px',
  textDecoration: 'underline'
};

export const DateTextSx: SxProps = {
  fontSize: '14px',
  fontWeight: 400
}; 
